import { render } from "./CommentHolder.vue?vue&type=template&id=79fb6226&scoped=true"
import script from "./CommentHolder.vue?vue&type=script&lang=js"
export * from "./CommentHolder.vue?vue&type=script&lang=js"

import "./CommentHolder.vue?vue&type=style&index=0&id=79fb6226&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79fb6226"]])

export default __exports__